import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M12.5,0.5L0,13l0.6,0.6L3.2,11v11.2c0,1.2,1,2.2,2.2,2.2h14.2c1.2,0,2.2-1,2.2-2.2V11.1l2.5,2.5L25,13L12.5,0.5z M15.5,23.5 H9.6V12.7h5.9V23.5z" />
    </g>
  </svg>
);
